document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.custom-liquid-column > :nth-child(1)');
  const img = document.querySelector('.media-column img');
  const video = document.querySelector('.media-column video');

  if (!form || (!img && !video)) return;

  const applyHeight = (height) => {
    if (img) {
      img.style.minHeight = height + 'px';
      img.style.maxHeight = height + 'px';
    }
    if (video) {
      video.style.minHeight = height + 'px';
      video.style.maxHeight = height + 'px';
    }
  };

  const resetHeight = () => {
    if (img) {
      img.style.minHeight = '';
      img.style.maxHeight = '';
    }
    if (video) {
      video.style.minHeight = '';
      video.style.maxHeight = '';
    }
  };

  const observer = new ResizeObserver(entries => {
    for (let entry of entries) {
      if (window.innerWidth > 768) {
        applyHeight(entry.contentRect.height);
      } else {
        resetHeight();
      }
    }
  });

  observer.observe(form);

  // Also re-check on resize
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 768) {
      resetHeight();
    }
  });
});